import type { CustomCSSProperties } from '../types/pbTypes';
import type { PbBorder, PbMargin, PbPadding, PbTextAlign } from '../types/pbShared';

/**
 * Returns the advanced settings of a component.
 * @param props
 * @returns CustomCSSProperties
 */

type AdvancedCustomCSSProperties = PbBorder & PbMargin & PbPadding & PbTextAlign;

export function getAdvancedSettings<T extends AdvancedCustomCSSProperties = AdvancedCustomCSSProperties>(
    props: T,
): CustomCSSProperties {
    const properties = {
        borderColor: props.borderColor,
        borderRadius: props.borderRadius,
        borderStyle: props.borderStyle,
        borderWidth: props.borderWidth,
        marginBottom: props.marginBottom,
        marginLeft: props.marginLeft,
        marginRight: props.marginRight,
        marginTop: props.marginTop,
        paddingBottom: props.paddingBottom,
        paddingLeft: props.paddingLeft,
        paddingRight: props.paddingRight,
        paddingTop: props.paddingTop,
        textAlign: props.textAlign,
    };

    if (props.padding) {
        properties['padding'] = props.padding;
    }

    if (props.margin) {
        properties['margin'] = props.margin;
    }

    return properties;
}
